import { IconNetwork, IconServer } from '@tabler/icons';

const icons = { IconNetwork, IconServer };

// ==============================|| SERVICES MENU ITEMS ||============================== //

const services = {
    id: 'services',
    // title: 'Paslaugos',
    type: 'group',
    children: [
        {
            id: 'network',
            title: 'Tinklo paslaugos',
            type: 'collapse',
            icon: icons.IconNetwork,

            children: [
                {
                    id: 'wiredNetwork',
                    title: 'Duomenų perdavimas',
                    type: 'item',
                    url: '/paslaugos/tinklas',
                    restriction: 'all'
                },
                {
                    id: 'wi-fi',
                    title: 'Saugi belaidė prieiga',
                    type: 'item',
                    url: '/paslaugos/wi-fi',
                    restriction: 'all'
                },
                {
                    id: 'eduroam',
                    title: 'Eduroam diegimas',
                    type: 'item',
                    url: '/paslaugos/eduroam',
                },
                {
                    id: 'vpn',
                    title: 'VPN',
                    type: 'item',
                    url: '/paslaugos/vpn',
                    restriction: 'all'
                },
                // {
                //     id: 'eduroam',
                //     title: 'Eduroam',
                //     type: 'item',
                //     url: '/paslaugos/eduroam'
                // }
            ]
        },
        // {
        //     id: 'eServices',
        //     title: 'E. paslaugos',
        //     type: 'collapse',
        //     icon: icons.IconServer,

        //     children: [
        //         {
        //             id: 'webServices',
        //             title: 'Web Paslaugos',
        //             type: 'collapse',
        //             children: [
        //                 {
        //                     id: 'orgsWithService',
        //                     title: 'Organizacijos turinčios paslaugą',
        //                     type: 'item',
        //                     url: '/e-paslaugos/web-paslauga/organizacijos'
        //                 },
        //                 {
        //                     id: 'allWebs',
        //                     title: 'Visi web',
        //                     type: 'item',
        //                     url: '/e-paslaugos/web-paslauga/visi-web'
        //                 }
        //             ]
        //         },
        //         {
        //             id: 'eMail',
        //             title: 'Paštas',
        //             type: 'item',
        //             url: '/e-paslaugos/pastas'
        //         },
        //         {
        //             id: 'identity',
        //             title: 'Tapatybės',
        //             type: 'collapse',
        //             children: [
        //                 {
        //                     id: 'sso',
        //                     title: 'SSO',
        //                     type: 'item',
        //                     url: '/e-paslaugos/tapatybes/sso'
        //                 },
        //                 {
        //                     id: 'federations',
        //                     title: 'Federacijos',
        //                     type: 'item',
        //                     url: '/e-paslaugos/tapatybes/federacijos'
        //                 }
        //             ]
        //         }
        //     ]
        // }
    ]
};

export default services;